import * as Store from 'store'
import { ROUTES } from 'config';
import createHistory from 'history/createBrowserHistory'

//Browser Navigation/Session History
const history = createHistory();

export const configureNavigation = (dispatch) => {
    history.listen((location) => {
        onNavigationChanged(dispatch)(location.pathname);
    });
    return history;
}


//** Redirect user to specific URL */
export const redirectTo = (dispatch, url) => {
    const currentUrl = history.location.pathname;
    if (url !== currentUrl) {
        console.debug(`Navigate to:[${url}]`);
        dispatch(Store.Navigation.navigationChanging(url, currentUrl))
        history.replace(url);
        return true;
    } else {
        console.debug(`Redirect to [${url}] => Ignored (already url)`)
        return false;
    }
}

// history change listener
const onNavigationChanged = (dispatch) => (url) => {
    dispatch(Store.Navigation.navigationChanged(url))
    //ToDo: review is this an action or should the notification reducer listen to navigation action?
    dispatch(Store.Notifications.clearNotifications());
}

/** Temp fix for all popups and issues on mobile   */
export const scrollToTop = () => {
    window.scrollTo(0, 0);
}

export interface IProtectedRouteFlags {
    isAuthenticated: boolean;
    isPendingEmailConfirmation: boolean;
    hasActiveSubscription: boolean;
}

/** Calculates valid route based on user state */
export const calculateProtectedRoute = (flags: IProtectedRouteFlags, dispatch): string => {
    if (flags.isAuthenticated) {
        if (flags.isPendingEmailConfirmation === true) {
            return ROUTES.EMAIL_PENDING;
        } else if (flags.hasActiveSubscription === false) {
            return ROUTES.SUBSCRIBE;
        }
    }
    return ROUTES.LANDING;
}

/** Verify current Route => Check if  */
export const validateCurrentRoute = (currentPath: string, flags: IProtectedRouteFlags, dispatch) => {
    const validRoute = calculateProtectedRoute(flags, dispatch);
    if (currentPath !== validRoute) {
        redirectTo(dispatch, validRoute);
    }
}


// WEBPACK FOOTER //
// ./src/application/navigation.ts